<template>
  <div class="relative flex items-center">
    <!-- Ícone de informação utilizando o FontAwesomeIcon -->
    <FontAwesomeIcon
      :icon="faCircleInfo"
      class="cursor-pointer"
      @mouseover="showTooltip = true"
      @mouseleave="showTooltip = false"
    />

    <!-- Tooltip -->
    <div v-if="showTooltip"
         class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-max px-2 py-1 text-sm text-white bg-gray-800 rounded-lg shadow-lg">
      {{ text }}
      <div class="tooltip-arrow absolute left-1/2 transform -translate-x-1/2 w-3 h-3 bg-gray-800 rotate-45"></div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  components: {
    FontAwesomeIcon
  },
  setup () {
    return {
      faCircleInfo
    }
  },
  data () {
    return {
      showTooltip: false
    }
  }
}
</script>

<style scoped>
.tooltip-arrow {
  bottom: -6px; /* Alinha o triângulo com o tooltip */
}
</style>
